import { render, staticRenderFns } from "./CollectWriteComponent.vue?vue&type=template&id=9dc8fa0e&scoped=true&"
import script from "./CollectWriteComponent.vue?vue&type=script&lang=js&"
export * from "./CollectWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc8fa0e",
  null
  
)

export default component.exports